<template>
    <div class="download-bar">
        <div class="logo_cont">
            <a class="logo_img" href="/"><img src="../assets/img/icon.png"></a>
            <div class="logo_title">
                <h1>{{g.gamename}}</h1>
                <p>{{g.short}}</p>
            </div>
        </div>
        <a class="download_btn" @click="download"><i class="iconfont icon-download"></i></a>
    </div>
</template>

<script>

// 移动端顶部下载条

import { platform } from '~/js/utils'
export default {
    name: 'DownloadBar',
    data () {
        // 按设备类型查找下载链接
        let link = this.g.download[platform.isIos ? 'ios' : 'android'],
            mol = platform.isIos ? '' : this.g.download.mol,
            huawei = platform.isIos ? '' : this.g.download.huawei
        return {
            link,
            mol,
            huawei
        }
    },
    methods: {
        // 下载提示，如果有链接，则提示跳转，无链接则提示未开放
        download () {
            if(this.link) {
                if(!this.mol && !this.huawei) {
                    this.$toase(this.$t('redirect'))
                    location.href = this.link
                } else {

                    let btns = []

                    if(this.mol) {
                        btns.push({
                            icon: 'iconfont icon-store',
                            type: 'success',
                            text: this.$t('thire_party_install'),
                            callback: () => {
                                this.$toase(this.$t('redirect'))
                                location.href = this.mol
                            }
                        })
                    }

                    if(this.huawei) {
                        btns.push({
                            icon: 'iconfont icon-huawei',
                            type: 'danger',
                            text: this.$t('download_huawei'),
                            callback: () => {
                                this.$toase(this.$t('redirect'))
                                location.href = this.huawei
                            }
                        })
                    }

                    btns.push({
                        icon: 'iconfont icon-android',
                        type: 'primary',
                        text: 'Google Play',
                        callback: () => {
                            this.$toase(this.$t('redirect'))
                            location.href = this.link
                        }
                    })

                    this.$message(this.$t('choose_to_download'), {
                        title: this.$t('tips'),
                        showClose: true,
                        btns
                    })
                }
            }else {
                this.$toase(this.$t('no_open_up'))
            }
        }
    }
}
</script>

<style lang="scss">
    /* 下载条样式 */
    .download-bar {
        width: 100%;
        padding: 0.16rem 0;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 2;
        background-color: rgba(0, 0, 0, 0.9);
        .logo_cont {
            padding-left: .16rem;
            margin: -.16rem auto
        }

        .logo_img {
            display: block;
            position: absolute;
            top: 50%;
            margin-top: -0.4rem;
            font-size: 0;
            img {
                width: 0.8rem;
                height: 0.8rem;
                vertical-align: top;
                border-radius: 0.08rem;
            }
        }

        .logo_title {
            display: table-cell;
            height: 1.12rem;
            padding: 0 2.12rem 0 .96rem;
            vertical-align: middle;
            font-size: 0;
            h1 {
                line-height: 0.44rem;
                font-size: .26rem;
                color: #fff;
            }

            p {
                font-size: .2rem;
                color: #999
            }
        }

        .download_btn {
            display: block;
            width: 1.12rem;
            height: 1.12rem;
            line-height: 1.12rem;
            top: 0;
            right: 0;
            position: absolute;
            text-align: center;
            text-decoration: none;
            font-size: 0;
            color: #fff;
            background-color: #FF5722;
            // animation: hue 16s linear infinite;
            .iconfont {
                font-size: .48rem;
            }
        }
    }
    
    .message-toolbar {
        padding: 0 7px;
        .btn {
            padding: 7px;
            .icon-huawei {
                display: inline-block;
                width: 12px;
                height: 13px;
                background: url(../assets/img/huawei-sm.png) center no-repeat;
                background-size: 100% auto;
            }
        }
    }

    @media (orientation: landscape) {
        /* 横屏 */
        .download-bar {
            position: absolute;
        }
    }

</style>